import { render, staticRenderFns } from "./navTitle.vue?vue&type=template&id=812e2eaa&"
import script from "./navTitle.vue?vue&type=script&lang=js&"
export * from "./navTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports